import styled from "styled-components";

const GameInfoList = styled.div`
  text-align: left;
  display: flex;
  margin-bottom: 2%;
`;

export default GameInfoList;
